import React, { forwardRef } from "react";

import { HelpIcon, type HelpIconProps } from "src/shared/HelpIcon";
import { Label as PrimitiveLabel } from "src/primitives/Label";
import { cn } from "src/shadcn/lib/utils";

export type { HelpIconProps };

export interface LabelProps extends React.ComponentProps<
  typeof PrimitiveLabel
> {
  /** Shows a red asterisk after the label text. */
  required?: boolean;
  /** Props for the help icon (tooltip or popover mode). */
  helpIconProps?: HelpIconProps;
  /** Additional CSS class names. */
  className?: string;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ required, helpIconProps, className, children, ...otherProps }, ref) => (
    <PrimitiveLabel ref={ref} className={cn(className)} {...otherProps}>
      {children}
      {required && (
        <span aria-hidden="true" className="text-destructive">
          *
        </span>
      )}
      {helpIconProps && <HelpIcon {...helpIconProps} />}
    </PrimitiveLabel>
  )
);

Label.displayName = "Label";

export { Label };
